<template>
    <div class="role-page full-height">
        <table-con>
            <div slot="breadcrumb">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/bad' }">{{$t('laund.laund1')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('laund.laund2')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div slot="search">
                <el-row class="search-row">
                    <el-col :span="8" class="display-row">
                        <div style="width:150px" class="query-title">{{$t('orderList.orderList2' || '订单编号')}}:</div>
                        <div class="flex1">
                            <el-input  :placeholder="$t('arrivalOrder.arrivalOrder2')" clearable v-model="queryInfo.orderNo" size="small" @keyup.enter.native="searchList">
                            </el-input>
                        </div>
                    </el-col>
                  <el-col :span="8" class="display-row">
                    <div style="width:150px" class="query-title">{{$t('select.select16' || '收件人')}}:</div>
                    <div class="flex1">
                      <el-input  :placeholder="$t('subAddress.subAddress1')" clearable v-model="queryInfo.receiverName" size="small" @keyup.enter.native="searchList">
                      </el-input>
                    </div>
                  </el-col>
                    <el-col :span="8" class="display-row">
                        <div style="text-align: right; width: 100%; padding-right: 10px">
                            <el-button class="search-btn btn-gray" @click="queryInfoClear">{{$t('laund.laund5')}}</el-button>
                            <el-button class="search-btn btn-blue" @click="searchList">{{$t('laund.laund6')}}</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div slot="table" class="full-height display-col" style="padding:10px">
                <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="dataList" border>
                  <el-table-column label="序号" type="index" align="center" width="50">
                    <template slot-scope="scope">
          <span>{{
              (queryInfo.pageNum - 1) * queryInfo.pageSize + scope.$index + 1
            }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="customerUserName" align="center" :label="$t('createOrder.createOrder102')"></el-table-column>

                  <el-table-column :label="$t('common.createDate')" align="center" prop="createTime">
                    <template slot-scope="scope">
                      <div style="width: 100%">
                        <div style="width: 100%">
                          {{ parseTime(scope.row.createTime, "{y}-{m}-{d}") }}
                        </div>
                        <div style="width: 100%">
                          {{ parseTime(scope.row.createTime, "{h}:{i}:{s}") }}
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('orderList.orderList2')" align="center" prop="goodsCode">
                    <template slot-scope="{ row }">
                      <div v-for="bundleOrder in row.bundleOrderListThree">
                        {{ bundleOrder.orderNo }}
                        <span>
                          {{ bundleOrder.orderStatus | orderStatusFilter }}
                        </span>
                      </div>

                      <div v-if="row.bundleOrderList && row.bundleOrderList.length > 3">
                        <el-tooltip placement="bottom" effect="light">
                          <template #content>
                            <div v-for="bundleOrder in row.bundleOrderList">
                              {{ bundleOrder.orderNo }}
                              <span>
                        {{ bundleOrder.orderStatus | orderStatusFilter }}
                      </span>
                            </div>
                          </template>
                          <div style="cursor: pointer">...</div>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="route" align="center" :label="$t('fba.line' || '线路')">
                    <template v-slot="scope">
                      {{scope.row.route === '1' ? $t('FBAContainerOrder.FBAContainerOrder1' || '空运'): $t('FBAContainerOrder.FBAContainerOrder2' || '海运')}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="companyNameJp" align="center" :label="$t('fba.logisticsCompany')"></el-table-column>
                  <el-table-column :label="$t('addr.addr2')" align="center" prop="receiver" >
                    <template slot-scope="{ row }">
                      <div style="text-align: left">
                        <div>{{$t('subAddress.subAddress4' || '姓名')}}{{row.receiverName}}</div>
                        <div>{{$t('subAddress.subAddress9' || '电话')}}{{row.receiverPhone}}</div>
                        <div>{{$t('subAddress.subAddress5' || '地址')}}{{row.receiverAddresserArea + row.receiverAddress}}</div>
                        <div>{{$t('subAddress.subAddress6' || '邮编')}}{{row.receiverZipCode}}</div>
                        <!--<div>邮箱：{{row.receiverEmail}}</div>-->
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column :label="$t('OrderDetail.OrderDetail24')" align="center" prop="clearance" >
                    <template slot-scope="{ row }">
                      <div style="text-align: left">
                        <div>{{$t('subAddress.subAddress4' || '姓名')}}{{row.senderName}}</div>
                        <div>{{$t('subAddress.subAddress9' || '电话')}}{{row.senderPhone}}</div>
                        <div>{{$t('subAddress.subAddress5' || '地址')}}{{row.senderAddresserArea + row.senderAddress}}</div>
                        <div>{{$t('subAddress.subAddress6' || '邮编')}}{{row.senderZipCode}}</div>
                        <!--<div>邮箱：{{row.senderEmail}}</div>-->
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum" :page-sizes="[5, 10, 20, 50, 100, 200]" :pager-count="5" :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
        </table-con>
    </div>
</template>

<script>
import tableCon from "../../views/tableContainer";

export default {
    components: { tableCon },
    data() {
        return {
            queryInfo: {
                orderNo:'',
                receiverName:'',
                pageSize: 10,
                pageNum: 1,
            },
            dataList: [],
            total: 0,
        };
    },
    methods: {
        handleSizeChange(newSize) {
            //分页
            this.queryInfo.pageSize = newSize;
            this.getDataList();
        },
        handleCurrentChange(newPage) {
            //分页
            this.queryInfo.pageNum = newPage;
            this.getDataList();
        },
        searchList() {
            //查询
            this.queryInfo.pageNum = 1;
            this.getDataList();
        },
        async getDataList() {
            //获取信息列表
            const { data: res } = await this.$http.get(
                "/bundle/list",
                { params: this.queryInfo }
            );
            this.dataList = res.list.map(item => {
              return{
                ...item,
                bundleOrderListThree: item.bundleOrderList.slice(0, 3),
              }
            })
            this.total = res.total;
        },
        //清空
        queryInfoClear() {
            this.queryInfo = {
                name: "",
                pageSize: 10,
                pageNum: 1,
            };
        },
      // 日期格式化
      parseTime(time, pattern) {
        if (arguments.length === 0 || !time) {
          return null
        }
        const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if (typeof time === 'object') {
          date = time
        } else {
          if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
          } else if (typeof time === 'string') {
            time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
          }
          if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
          }
          date = new Date(time)
          // date = new Date(addHourToTimestamp(time))
        }
        const formatObj = {
          y: date.getFullYear(),
          m: date.getMonth() + 1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
          let value = formatObj[key]
          // Note: getDay() returns 0 on Sunday
          if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
          if (result.length > 0 && value < 10) {
            value = '0' + value
          }
          return value || 0
        })
        return time_str
      },
    },
    watch: {},
    created() {
        this.getDataList();
    },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
    height: 60px !important;
}

.el-table .el-button--small {
    padding: 4px 10px;
}
.imgBox {
    display: flex;
}
.imgBox .img {
    margin-right: 2px;
    width: 35px !important;
    height: 35px !important;
}
.el-table img {
    width: 35px !important;
    height: 35px !important;
}
</style>
